module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "file_023"
    }
  }, [_vm._v("basic techniques")])]), _c('a', {
    attrs: {
      "id": "file_023"
    }
  }), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "file_023"
    }
  }), _c('a', {
    attrs: {
      "id": "file_023a"
    }
  }, [_vm._v("1. Needling")])]), _c('a', {
    attrs: {
      "id": "file_023a"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hold the felting needle in your hand like a pen or pencil. Poke the needle straight into the wool "), _c('strong', [_vm._v("(A)")]), _vm._v(". The needle doesn’t need to penetrate the surface more than ¼″ (6 mm) because the barbs are only on the tip of the needle. Lift and poke with the needle, enough to secure the fibers into place. The more you poke, the tighter the fibers get "), _c('strong', [_vm._v("(B)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-02.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d2d9a0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_023.vue
// module id = 120
// module chunks = 0